import React, { createContext, useContext, useState, useEffect } from 'react';

const StatsContext = createContext();

export const StatsProvider = ({ children }) => {
  const [stats, setStats] = useState({
    googleReviews: '340',
    websitePrice: '40',
    loading: true,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch('https://erstehilfe-fokus.de/buchungssystem/api.php?action=stats');
        const data = await response.json();
        
        if (data.status === 'success') {
          setStats({
            googleReviews: data.google_reviews || '340',
            websitePrice: parseFloat(data.website_price).toFixed(0) || '40',
            loading: false,
          });
        } else {
          setStats(prev => ({ ...prev, loading: false }));
        }
      } catch {
        // Silent fail - keep default values
        setStats(prev => ({ ...prev, loading: false }));
      }
    };

    fetchStats();
  }, []);

  return (
    <StatsContext.Provider value={stats}>
      {children}
    </StatsContext.Provider>
  );
};

export const useStats = () => {
  const context = useContext(StatsContext);
  if (!context) {
    return { googleReviews: '340', websitePrice: '40', loading: false };
  }
  return context;
};
